import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-data-table-v2',
  imports: [CommonModule],
  templateUrl: './data-table-v2.component.html',
  styleUrls: ['./data-table-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTableV2Component {
  @Input() data: any[] = [];
  @Input() header: TemplateRef<any> | null = null;
  @Input() body: TemplateRef<any> | null = null;
  @Input() action: TemplateRef<any> | null = null;

  @Input() title: string | null = null;
}
